import { useEffect, useState } from "react";
import { useAuth } from "@/auth/AuthProvider";
import { getOwnerTitles, type OwnerTitles } from "@/lib/brokerOwnerTitles";
import { messageFor } from "@/lib/errors";

/** The owners' titles by legal entity, read once for the page that asks them
 *  (BRK-S391), with a problem and Retry when the read fails. */
export function useOwnerTitles() {
  const { authedRequest } = useAuth();
  const [items, setItems] = useState<OwnerTitles[] | null>(null);
  const [problem, setProblem] = useState<string | null>(null);
  const [attempt, setAttempt] = useState(0);
  useEffect(() => {
    let cancelled = false;
    setProblem(null);
    getOwnerTitles(authedRequest).then(
      ({ items }) => {
        if (!cancelled) setItems(items);
      },
      (err: unknown) => {
        if (!cancelled) setProblem(messageFor(err));
      },
    );
    return () => {
      cancelled = true;
    };
  }, [attempt, authedRequest]);
  return { items, problem, retry: () => setAttempt((n) => n + 1) };
}
